export default __webpack_public_path__ + "static/article-renovation-new-floor-7bbe3f746ab610c42e577e326bfe6b81.jpg";